import { useTranslation } from 'react-i18next'
import { useModal } from '../../hooks/useModal'
import { Button } from '../Button'
import { IoClose } from 'react-icons/io5'

export function Modal() {
  const {
    closeModal,
    modalState: {
      visible,
      description,
      title,
      children,
      confirm,
      singleButton,
      textConfirm,
      small,
    },
  } = useModal()

  const { t } = useTranslation()
  const isCompactModal = small || !children

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center px-4 py-4 ${
        visible ? 'visible' : 'hidden'
      } overflow-hidden`}
    >
      <div
        onClick={() => closeModal()}
        className="bg-gray-700/80 absolute inset-0"
      />
      <div className="relative z-10 w-full flex items-center justify-center">
        <div
          className={`relative flex min-h-[191px] w-full min-w-0 ${
            isCompactModal ? 'max-w-[560px]' : 'max-w-[900px]'
          } flex-col justify-between overflow-visible rounded-[20px] bg-white p-5 shadow-xl md:max-h-[calc(100vh-1rem)] md:p-4`}
        >
          <button
            className="bg-purple-600 absolute -top-3 -right-3 w-9 h-9 rounded-full flex items-center justify-center "
            onClick={closeModal}
          >
            <IoClose color="#fff" />
          </button>

          {children ? (
            <div className="modal-scroll min-h-0 max-h-[calc(100vh-12.5rem)] overflow-y-auto pr-2 md:max-h-[calc(100vh-8rem)] md:pr-1">
              {children}
            </div>
          ) : (
            <>
              <div>
                <p className="text-lg font-bold">{title}</p>
                <div className="bg-purple-600 rounded-3xl h-1 w-6" />
                <p className="text-sm font-normal mt-4">{description}</p>
              </div>

              <div className="h-[1px] bg-gray-300/50 max-w-[598px] my-5 md:max-w-full" />

              {singleButton ? (
                <Button
                  title="Close"
                  variant="green"
                  onClick={() => {
                    if (confirm) confirm()
                    closeModal()
                  }}
                />
              ) : (
                <div className="flex items-end justify-between">
                  <button
                    onClick={closeModal}
                    className="text-gray-700 underline text-sm font-normal hover:text-gray-700/90"
                  >
                    Back
                  </button>
                  <Button
                    className="w-[93px]"
                    variant="red"
                    title={textConfirm || t('buttonDelete')}
                    onClick={() => {
                      if (confirm) confirm()
                      closeModal()
                    }}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}
